import { Axios } from 'utils/AxiosConfig'

export const getCompanyForSale = async (payload) => {
  const { data: response } = await Axios.get(`public/filter/company-for-sale`, payload)
  return response
}
export const getCompanyForSaleDetail = async (id) => {
  const { data: response } = await Axios.get(`public/filter/company-for-sale/${id}`)
  return response
}
export const postFavoriteCompanyForSale = async (payload) => {
  const { data: response } = await Axios.post(`member/favorite/company-for-sale`, payload)
  return response
}
export const getAvailibityPackage = async (payload) => {
  const { data: response } = await Axios.get(`member/contact-request/check-limit`, {
    params: payload
  })
  return response
}
export const getNdaContent = async () => {
  const { data: response } = await Axios.get(`member/nda-platform`)
  return response
}
export const putAcceptNda = async () => {
  const { data: response } = await Axios.put(`member/nda-platform/accept`)
  return response
}